var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"editable",class:{
    'forced-user-select-initial': _vm.editing,
    'whitespace-pre-wrap': _vm.multiline,
    'editable--multi-line': _vm.multiline,
  },attrs:{"contenteditable":_vm.editing,"placeholder":_vm.placeholder},on:{"input":_vm.update,"keydown":_vm.keydown,"focusout":_vm.change,"paste":_vm.paste}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }